import { useCallback, useContext } from "react";

import { usePathDefinitionFromContext } from "../../navigation/router/UsePathDefinitionContext";
import {
  AppFrontVersionContext,
  AppLogServiceContext,
} from "../AppErrorProvider";
import { useErrorNamespace } from "../ErrorNamespaceProvider";

export const NULL_VALUE_ERROR_CODE = "NULL_VALUE_IN_NON_NULLABLE_FIELD";

export const ERROR_TYPES = {
  RUNTIME: "RUNTIME",
  REQUEST: "REQUEST",
};

export const LOGGER_SERVICES = {
  [ERROR_TYPES.RUNTIME]: "javascript-error-tracks/runtime-error-tracks",
  [ERROR_TYPES.REQUEST]: "javascript-error-tracks/request-error-tracks",
};

export const FRONTEND_API_URL = "/frontend-api/service/graphql";

const errorTrackerFetcher = (logService, type, errorInfo) => {
  if (!fetch) return;

  fetch(`${logService}/${LOGGER_SERVICES[type]}`, {
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(errorInfo),
  }).catch(() => {
    // eslint-disable-next-line no-console
    console.warn(
      `JSLogger service not available for ${type}: ${logService}/${LOGGER_SERVICES[type]} with body: ${errorInfo}`,
    );
  });
};

export const isNullValueErrorDerivedFromOtherError = (errors, errorCode) =>
  errors.length > 1 && errorCode === NULL_VALUE_ERROR_CODE;

export const useRuntimeErrorTracker = (namespace) => {
  const logService = useContext(AppLogServiceContext);
  const frontVersion = useContext(AppFrontVersionContext);
  const moduleNamespace = useErrorNamespace();
  const pageName = usePathDefinitionFromContext();

  return useCallback(
    (logInfo) => {
      errorTrackerFetcher(logService, ERROR_TYPES.RUNTIME, {
        ...logInfo,
        npmModule: namespace ?? moduleNamespace,
        href: window?.location?.href,
        frontVersion,
        pageName,
      });
    },
    [logService, namespace, moduleNamespace, frontVersion, pageName],
  );
};

export const useRequestErrorTracker = (namespace) => {
  const logService = useContext(AppLogServiceContext);
  const frontVersion = useContext(AppFrontVersionContext);
  const moduleNamespace = useErrorNamespace();
  const pageName = usePathDefinitionFromContext();

  return useCallback(
    (logInfo) => {
      errorTrackerFetcher(logService, ERROR_TYPES.REQUEST, {
        ...logInfo,
        requestUrl: FRONTEND_API_URL,
        npmModule: namespace ?? moduleNamespace,
        href: window?.location?.href,
        frontVersion,
        pageName,
      });
    },
    [logService, namespace, moduleNamespace, frontVersion, pageName],
  );
};
